import { Titled } from 'react-titled';
import type { FC } from 'react';
import TwitterFormProvider from 'features/twitter/components/TwitterFormProvider';

const TwitterPage: FC = () => (
  <>
    <Titled title={(title) => `WellTech User Acquisition | ${title}`} />
    <TwitterFormProvider />
  </>
);

export default TwitterPage;
